import { ModalWindow } from "../UI/ModalWindow";
import { Input } from '../UI/FormElements'

const ROUTE_URL = "/units";
const initialData = { name: "", unit_measure: "" };

function Unit({ params, handleClose }) {

  let urlSubmit, urlGet;
  if (params.isNew) {
    urlSubmit = ROUTE_URL;
    urlGet = ""; //или ROUTE_URL + "/create" если при создании НАДО предварительное обращение к серверу
  }
  else {
    urlGet = ROUTE_URL + "/" + params.id;
    urlSubmit = urlGet;
  }
  return (
    <ModalWindow params={params} handleClose={handleClose} initialData={initialData} urlGet={urlGet} urlSubmit={urlSubmit} >
      <UnitFields />
    </ModalWindow>
  );
}

const UnitFields = ({ dopParams, ...elementProps }) => {
  return (
    <div className="row form-gutter">
      <div className="col-12">
        <Input label="Наименование единицы учета" name="name" {...elementProps} required autoFocus />
      </div>
      <div className="col-12">
        <Input label="Единица измерения" name="unit_measure" {...elementProps} required />
      </div>
    </div>
  )
}

export default Unit;